import { Component, ChangeDetectionStrategy, Inject } from "@angular/core";
import { MatCalendar } from "@angular/material/datepicker";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

@Component({
    selector: "vui-custom-calendar-header",
    templateUrl: "./custom-calendar-header.component.html",
    styleUrls: ["./custom-calendar-header.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VuiCalendarHeaderComponent<D> {
    constructor(
        public calendar: MatCalendar<D>,
        private _dateAdapter: DateAdapter<D>,
        @Inject(MAT_DATE_FORMATS) private _dateFormats: any
    ) {}

    get periodButtonText(): string {
        // Customize the period button text here
        if (this.calendar.currentView === "month") {
            let date = this.calendar.activeDate as Date;
            let formatted = format(date, "MMMM yyyy", { locale: ptBR });
            return formatted.charAt(0).toUpperCase() + formatted.slice(1);
        } else if (this.calendar.currentView === "year") {
            return this._dateAdapter.getYear(this.calendar.activeDate).toString();
        } else {
            // multi-year view
            const startYear = this._dateAdapter.getYear(
                this._dateAdapter.addCalendarYears(this.calendar.activeDate, -6)
            );
            const endYear = this._dateAdapter.getYear(this._dateAdapter.addCalendarYears(this.calendar.activeDate, 5));
            return `${startYear} - ${endYear}`;
        }
    }

    previousClicked(mode: "month" | "year" | "multi-year") {
        this.calendar.activeDate =
            mode === "month"
                ? this._dateAdapter.addCalendarMonths(this.calendar.activeDate, -1)
                : this._dateAdapter.addCalendarYears(this.calendar.activeDate, -1);
    }

    nextClicked(mode: "month" | "year" | "multi-year") {
        this.calendar.activeDate =
            mode === "month"
                ? this._dateAdapter.addCalendarMonths(this.calendar.activeDate, 1)
                : this._dateAdapter.addCalendarYears(this.calendar.activeDate, 1);
    }

    currentPeriodClicked() {
        this.calendar.currentView = this.calendar.currentView === "month" ? "multi-year" : "month";
    }
}
